import { render } from "./ProfessionSliderComponent.vue?vue&type=template&id=2fccf2e2&scoped=true"
import script from "./ProfessionSliderComponent.vue?vue&type=script&lang=js"
export * from "./ProfessionSliderComponent.vue?vue&type=script&lang=js"

import "./ProfessionSliderComponent.vue?vue&type=style&index=0&id=2fccf2e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fccf2e2"]])

export default __exports__